<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="showDialog"
      width="30%"
      @close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="是否开启学生匿名：" prop="isnm">
          <el-switch v-model="ruleForm.isnm"></el-switch>
        </el-form-item>
        <div class="form-tip-text">
          开启后用户可匿名提交心愿
        </div>
        <el-form-item style="margin-top: 20px;">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  CheckNMApi,
  SetIsNM_adminApi
} from "@/request/requestApi.js";

export default {
  data() {
    return {
      dayOptions: [
        { value: 0, label: "小于" },
        { value: 1, label: "大于" }
      ],
      weekOptions: [
        { value: "1", label: "周一" },
        { value: "2", label: "周二" },
        { value: "3", label: "周三" },
        { value: "4", label: "周四" },
        { value: "5", label: "周五" },
        { value: "6", label: "周六" },
        { value: "0", label: "周日" }
      ],
      ruleForm: {
        isnm: false,
      },
      rules: {
        autoAuditDay: [
          { required: true, message: "请填写申请返校天数", trigger: "blur" },
          { type: "number", min: 0, message: "请输入合规天数", trigger: "blur" }
        ],
        isDayOfWeek: [
          { required: true, message: "请选择预约日期规则", trigger: "change" }
        ]
      }
    };
  },
  watch: {
    "ruleForm.isDayOfWeek": function(val) {
      if (!val) {
        // 隐藏时移除 dayOfWeekArray 的验证规则
        delete this.rules.dayOfWeekArray;
      } else {
        // 显示时添加 dayOfWeekArray 的验证规则
        this.$set(this.rules, "dayOfWeekArray", [
          { required: true, message: "请选择可预约的天数", trigger: "change" }
        ]);
      }
    },
    "ruleForm.isBefore": function(val) {
      if (!val) {
        // 隐藏时移除 beforeDay 的验证规则
        delete this.rules.beforeDay;
      } else {
        // 显示时添加 beforeDay 的验证规则
        this.$set(this.rules, "beforeDay", [
          {
            required: true,
            message: "请填写用户需要提前的天数",
            trigger: "blur"
          },
          { type: "number", message: "天数不合规，请检查", trigger: "blur" }
        ]);
      }
    },
    showDialog(val) {
      // 当 showDialog 为 true 时调用获取数据的方法
      if (val) {
        this.getReturnSchoolPrebookSet();
      }
    }
  },
  created() {
    this.getReturnSchoolPrebookSet();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 在这里执行提交逻辑，例如调用 SetIsNM_adminApi
          this.setReturnSchoolPrebook();
        } else {
          console.log("验证失败!");
          return false;
        }
      });
    },
    async setReturnSchoolPrebook() {
      let res = await SetIsNM_adminApi(this.ruleForm);
      if (res.succeed) {
        this.$message.success("操作成功！");
        this.handleClose();
      }
    },
    async getReturnSchoolPrebookSet() {
      let res = await CheckNMApi();
      if (res.succeed) {
        this.ruleForm.isnm = res.data;
      }
    },

    handleClose() {
      // this.resetForm("ruleForm");
      this.$emit("closeSetDialog");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.form-tip-text {
  font-size: 12px;
  color: #ff4a4a;
  margin-bottom: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/view/wishManage/components/setDialog.vue